/*
 * File: PageSubHeader.tsx
 * Project: meryl-sheep
 * -----
 * Last Modified: 12 Oct 2020 11:55:01 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { Col, Row } from 'antd';
import { EntitySelector } from 'components/atoms/EntitySelector';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';

const styles: InlineStylesModel = {
  row: {
    backgroundColor: '#181823',
    padding: '0 50px',
    color: '#84859a',
    fontSize: '1rem',
    maxWidth: 1920,
    margin: '0 auto',
    height: 50
  },
  menuContainer: {
    height: '100%',
    width: '100%'
  },
  smallContainer: {
    width: 177
  },
  largeContainer: {
    width: 308
  }
};

export const PageSubHeader = (): JSX.Element => {
  return (
    <div style={{ width: '100%', backgroundColor: 'rgb(24, 24, 35)' }}>
      <Row style={styles.row} justify="space-between" align="middle">
        <Col>
          <EntitySelector />
        </Col>
      </Row>
    </div>
  );
};
